import styled from '@emotion/styled';
import React from 'react';
import {ESmallButton} from 'webapp-lib/Components';
import {
  mixinFlexboxColumn,
  mixinFlexboxRow,
  mixinOverflowYWithGutter,
  mixinTruncate,
} from 'webapp-lib/styling';

import {Add} from '_/assets/images';

import {DraggableWorkLogSuggestion, EventTimers} from '../../types';
import {toMinutes} from '../../utilities/date';

import {FavoriteTemplate} from './FavoriteTemplate';
import {SectionTitle} from './styles';

export const CALENDAR_FAVORITE_CONTAINER = 'cal-favorite-list';

export const Favorites = ({
  timer,
  favorites,
  showDialog,
  setEditingFavorite,
  onFavoriteDeleted,
}: {
  timer: EventTimers;
  favorites: DraggableWorkLogSuggestion[];
  showDialog: () => void;
  setEditingFavorite: (item: DraggableWorkLogSuggestion | undefined) => void;
  onFavoriteDeleted: (deleted: DraggableWorkLogSuggestion) => void;
}): React.ReactElement => {
  const handleStartTimer = (item: DraggableWorkLogSuggestion) => {
    timer.start({
      title: item.title,
      description: item.description,
      activity: item.activity,
      color: item.color,
    });
  };

  return (
    <>
      <StyledFavorite>
        <HeaderRow>
          <SectionTitle>Favoriten</SectionTitle>
          <ESmallButton Icon={Add} onClick={showDialog}>
            Neu
          </ESmallButton>
        </HeaderRow>
        <StyledFavoriteList id={CALENDAR_FAVORITE_CONTAINER}>
          {favorites.map((workLog) => (
            <FavoriteTemplate
              key={workLog.id}
              data={workLog}
              onDelete={onFavoriteDeleted}
              onEdit={setEditingFavorite}
              onStartTimer={() => handleStartTimer(workLog)}
            >
              <Title>{workLog.title}</Title>
              <Description>{workLog.description}</Description>
              {workLog.defaultDurationSeconds != null && (
                <Description>
                  {toMinutes(workLog.defaultDurationSeconds)} Min
                </Description>
              )}
            </FavoriteTemplate>
          ))}
        </StyledFavoriteList>
      </StyledFavorite>
    </>
  );
};

const HeaderRow = styled.div`
  ${mixinFlexboxRow};
`;

const StyledFavorite = styled.div`
  ${mixinFlexboxColumn};

  min-height: 0;
`;

const StyledFavoriteList = styled.div`
  ${mixinFlexboxColumn};
  ${mixinOverflowYWithGutter};

  flex-grow: 1;
  gap: var(--gutter-small);
`;

const Title = styled.div`
  color: var(--color-core-primary);
  font-size: var(--font-size-default);
  font-weight: var(--font-weight-subtitle);
`;
export const Description = styled.div`
  ${mixinTruncate};

  color: var(--color-core-link);
  font-size: var(--font-size-tiny);
`;
